import { TableProps } from "antd";
import { capitalize } from "lodash";
import moment from "moment";
import CustomTable from "../../../components/ui/CustomTable";
import { dateFormat } from "../../../constants/constants";
import { useGetTaskQueuesQuery } from "../../../features/taskQueue/taskQueueApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import {
  addKeyInArray,
  underscoreToCapitalizeString,
} from "../../../utils/utils";
enum Status {
  pending = "status-warning",
  success = "status-success",
  failed = "status-danger",
}
const TaskQueue = () => {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const { data, isLoading, isFetching, isError, error } = useGetTaskQueuesQuery(
    { params: { page, limit } }
  );
  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
      // render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="text-nowrap w-[165px]">Name</div>,
      dataIndex: "task_name",
      render: (val) => underscoreToCapitalizeString(val || "-"),
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      render: (val) =>
        val ? moment(val).format(`${dateFormat} hh:mm A`) : "-",
    },
    {
      title: "Error Response",
      dataIndex: "response",
      render: (val) => val || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (val: keyof typeof Status) => (
        <span className={`${Status[val]}`}>{capitalize(val)}</span>
      ),
    },
  ];

  useError(isError, error, "Get task queue list fail");
  return (
    <SidebarLayout title="Task Queue">
      <CustomTable
        loading={isLoading || isFetching}
        columns={columns}
        dataSource={addKeyInArray(data?.data?.reports || [], "id")}
        limit={limit}
        page={page}
        total={data?.data?.total || 0}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
      />
    </SidebarLayout>
  );
};

// const data = [
//   {
//     id: 14,
//     business_id: 349,
//     status: "failed",
//     response: "Salary already generated in this cycle",
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T18:05:18.000Z",
//     updated_at: "2025-08-05T18:05:19.000Z",
//   },
//   {
//     id: 12,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T18:05:09.000Z",
//     updated_at: "2025-08-05T17:23:43.000Z",
//   },
//   {
//     id: 13,
//     business_id: 349,
//     status: "failed",
//     response: "Salary already generated in this cycle",
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:35:09.000Z",
//     updated_at: "2025-08-05T17:35:11.000Z",
//   },
//   {
//     id: 11,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:19:13.000Z",
//     updated_at: "2025-08-05T17:19:15.000Z",
//   },
//   {
//     id: 10,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:15:04.000Z",
//     updated_at: "2025-08-05T17:15:05.000Z",
//   },
//   {
//     id: 9,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:13:20.000Z",
//     updated_at: "2025-08-05T17:13:21.000Z",
//   },
//   {
//     id: 8,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:12:28.000Z",
//     updated_at: "2025-08-05T17:12:30.000Z",
//   },
//   {
//     id: 7,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:11:25.000Z",
//     updated_at: "2025-08-05T17:11:26.000Z",
//   },
//   {
//     id: 6,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:09:14.000Z",
//     updated_at: "2025-08-05T17:09:16.000Z",
//   },
//   {
//     id: 5,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:08:31.000Z",
//     updated_at: "2025-08-05T17:08:33.000Z",
//   },
//   {
//     id: 4,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "Salary generation",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T17:05:40.000Z",
//     updated_at: "2025-08-05T17:05:42.000Z",
//   },
//   {
//     id: 3,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "generate salary queue",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T16:49:07.000Z",
//     updated_at: "2025-08-05T16:49:09.000Z",
//   },
//   {
//     id: 2,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "generate salary queue",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T16:47:42.000Z",
//     updated_at: "2025-08-05T16:47:43.000Z",
//   },
//   {
//     id: 1,
//     business_id: 349,
//     status: "success",
//     response: null,
//     task_name: "generate salary queue",
//     created_by: 1226,
//     created_by_name: "moveUser",
//     created_at: "2025-08-05T16:38:06.000Z",
//     updated_at: "2025-08-05T16:38:08.000Z",
//   },
// ];

export default TaskQueue;
